'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Map;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutable = require('immutable');

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

var _Lazy = require('../routeHandlers/Lazy');

var _appStepRoutes = require('./appStepRoutes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var specialAndErrorHandlers = (0, _immutable.Map)((_Map = {}, _defineProperty(_Map, _appStepRoutes.INVITED_ERROR, function (props) {
  return _react2.default.createElement(
    _react2.default.Suspense,
    { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
    _react2.default.createElement(_Lazy.TokenError, props)
  );
}), _defineProperty(_Map, _appStepRoutes.GENERAL_ERROR, function (props) {
  return _react2.default.createElement(
    _react2.default.Suspense,
    { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
    _react2.default.createElement(_Lazy.GeneralError, props)
  );
}), _defineProperty(_Map, _appStepRoutes.FORCE_LOGIN, function (props) {
  return _react2.default.createElement(
    _react2.default.Suspense,
    { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
    _react2.default.createElement(_Lazy.GoToLogin, props)
  );
}), _defineProperty(_Map, _appStepRoutes.FORCE_FB_LOGIN, function (props) {
  return _react2.default.createElement(
    _react2.default.Suspense,
    { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
    _react2.default.createElement(_Lazy.FbGoToLogin, props)
  );
}), _defineProperty(_Map, _appStepRoutes.FORCE_PARTNER_LOGIN, function (props) {
  return _react2.default.createElement(
    _react2.default.Suspense,
    { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
    _react2.default.createElement(_Lazy.PartnerGoToLogin, props)
  );
}), _defineProperty(_Map, _appStepRoutes.GOOGLE_OAUTH, function (props) {
  return _react2.default.createElement(
    _react2.default.Suspense,
    { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
    _react2.default.createElement(_Lazy.GoogleOAuth, props)
  );
}), _defineProperty(_Map, _appStepRoutes.GOOGLE_OAUTH_LANDING, function (props) {
  return _react2.default.createElement(
    _react2.default.Suspense,
    { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
    _react2.default.createElement(_Lazy.GoogleOAuthLanding, props)
  );
}), _defineProperty(_Map, _appStepRoutes.GETTING_STARTED_FALLBACK, function (props) {
  return _react2.default.createElement(
    _react2.default.Suspense,
    { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
    _react2.default.createElement(_Lazy.GettingStarted, props)
  );
}), _defineProperty(_Map, _appStepRoutes.EXISTING_ACCOUNT_LOGIN, function (props) {
  return _react2.default.createElement(
    _react2.default.Suspense,
    { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
    _react2.default.createElement(_Lazy.ExistingAccountLogin, props)
  );
}), _Map));

exports.default = specialAndErrorHandlers;
module.exports = exports['default'];